export default __webpack_public_path__ + "static/contact-hero-b-d160b854807fabf543f45588d1b354bd.svg";